import React from 'react';
import { arrayOf, bool, func, number, object, shape, string, array } from 'prop-types';
import Card from '../Card/Card';
import LoadingIndicator from 'ps-components/LoadingIndicator/LoadingIndicator';
import SkillAdhoc from './AdHoc';
import SkillTable from './SkillTable';
import { DIFFERENTIAL_TYPE, PRICING_TYPE } from '../SkillGeoDifferentialReducer';

const SKILL_CARD_DESCRIPTION =
  'Add popular or needed skills to this job and find out how much they are worth nationally';

class SkillDifferentialCard extends React.Component {
  static propTypes = {
    addJob: shape({
      jobTitles: arrayOf(object),
      noJobCode: bool
    }),
    autoMatchLoading: bool,
    cancelEditJobTitle: func,
    editMatch: func,
    isAdded: bool,
    isApplied: bool,
    isEditing: bool,
    isExpanded: bool,
    isRemoved: bool,
    jobCode: string,
    orgJobId: number,
    orgJobTitle: string,
    overrideTitle: func,
    selectedJobTitle: string,
    setSkillsDifferentialIsRemoved: func,
    skillsError: string,
    skillsByJobList: object,
    titleJobSearch: func,
    toggleSkillsCard: func,
    toggleSkillsCardExpand: func,
    pricingType: string,
    setIsPendingRemove: func,
    isPendingRemove: bool,
    disabled: bool,
    featureIsPurchased: bool,
    getJobTasks: func,
    clearAddJobState: func,
    resetSkillsState: func,
    skills: array,
    skillsLoaded: bool,
    setSelectedJobTitle: func,
    skillDifferentialSearch: func,
    slideout: shape({
      open: bool
    })
  };

  componentDidMount() {
    const { setSelectedJobTitle, orgJobId, selectedJobTitle, featureIsPurchased } = this.props;

    if (!featureIsPurchased) {
      this.notPurchasedSearch();
    }

    if (selectedJobTitle) {
      setSelectedJobTitle(selectedJobTitle, orgJobId, true);
    }
  }

  componentDidUpdate(prevProps) {
    const { isAdded, clearAddJobState, resetSkillsState, slideout, featureIsPurchased } = this.props;

    if (!isAdded && prevProps.isAdded) {
      resetSkillsState();
      clearAddJobState();
    }

    if (!featureIsPurchased && slideout.open && !prevProps.slideout.open) {
      this.notPurchasedSearch();
    }
  }

  notPurchasedSearch = () => {
    const { skillDifferentialSearch, getJobTasks, orgJobId } = this.props;
    skillDifferentialSearch('Senior Software Engineer');
    getJobTasks('Senior Software Engineer', orgJobId);
  };

  handleJobClick = (jobId, jobTitle, tasks, titleVariations, titleSelected, row) => {
    const { overrideTitle, resetSkillsState, skillDifferentialSearch } = this.props;

    resetSkillsState();
    skillDifferentialSearch(jobTitle, 'United States', jobId);
    overrideTitle(jobTitle);
  };

  openJobSearch = () => {
    const { editMatch, selectedJobTitle, titleJobSearch } = this.props;

    editMatch();
    titleJobSearch(selectedJobTitle);
  };

  renderTemplateBeforeAdd = () => {
    return (
      <div className="card__row vertical-padding">
        <p className="pxl-text-muted">{SKILL_CARD_DESCRIPTION}</p>
      </div>
    );
  };

  renderTemplateAfterAdd = () => {
    const {
      addJob,
      autoMatchLoading,
      cancelEditJobTitle,
      isEditing,
      isInitialLoad,
      orgJobId,
      orgJobTitle,
      sampleSize,
      selectedJobTitle,
      selectedSkills,
      showSearch,
      skills,
      skillsError,
      skillsLoaded,
      tasks,
      titleJobSearch,
      toggleSkill,
      toggleSkillsSearch,
      featureIsPurchased
    } = this.props;
    let job;

    if (addJob?.jobTitles?.length > 0 && selectedJobTitle) {
      job = addJob.jobTitles.find(job => job.JobTitle === selectedJobTitle);
    }

    if (autoMatchLoading) return <LoadingIndicator />;

    return (!autoMatchLoading && !isEditing && !showSearch && skillsError.length === 0) || !featureIsPurchased ? (
      <SkillTable
        openJobSearch={this.openJobSearch}
        sampleSize={sampleSize}
        selectedJobTitle={selectedJobTitle}
        selectedSkills={selectedSkills}
        skills={skills}
        skillsLoaded={skillsLoaded}
        tasks={job ? job.Tasks : tasks}
        toggleSkill={toggleSkill}
        featureIsPurchased={featureIsPurchased}
      />
    ) : (
      <SkillAdhoc
        addJob={addJob}
        cancelEditJobTitle={cancelEditJobTitle}
        editJobTitleMode={isEditing}
        handleJobClick={this.handleJobClick}
        isEditing={isEditing}
        isInitialLoad={isInitialLoad}
        orgJobId={orgJobId}
        orgJobTitle={selectedJobTitle ? selectedJobTitle : orgJobTitle}
        showSearch={showSearch}
        skills={skills}
        skillsError={skillsError}
        titleJobSearch={titleJobSearch}
        toggleSkillsSearch={toggleSkillsSearch}
      />
    );
  };

  render() {
    const {
      isAdded,
      isExpanded,
      toggleSkillsCard,
      toggleSkillsCardExpand,
      selectedSkills,
      differential,
      differentialOverride,
      updateDifferentialOverride,
      isRemoved,
      setSkillsDifferentialIsRemoved,
      isApplied,
      pricingType,
      setIsPendingRemove,
      isPendingRemove,
      disabled
    } = this.props;

    return (
      <Card
        count={selectedSkills.length}
        icon="icon-tools"
        id="skill"
        isAdded={isAdded}
        isApplied={isApplied}
        isExpanded={isExpanded}
        isRemoved={isRemoved}
        setRemoved={setSkillsDifferentialIsRemoved}
        templateAfterAdd={this.renderTemplateAfterAdd()}
        templateBeforeAdd={this.renderTemplateBeforeAdd()}
        title="Skills Differential"
        toggleDifferential={toggleSkillsCard}
        toggleExpand={toggleSkillsCardExpand}
        totalAdjustment={differential}
        totalAdjustmentOverride={differentialOverride}
        updateTotalAdjustmentOverride={updateDifferentialOverride}
        pricingType={pricingType}
        differentialType={DIFFERENTIAL_TYPE.SKILL}
        setIsPendingRemove={setIsPendingRemove}
        isPendingRemove={isPendingRemove}
        disabled={disabled}
      />
    );
  }
}

export default SkillDifferentialCard;
